<div class="p8-setting-footer__container" fxLayoutAlign="{{flexLayoutAlign}}" fxLayoutGap="10px">
  <ng-content></ng-content>
</div>

